<app-header [title]="'upload.title' | translate"></app-header>

<app-upload-options
  (uploadCompleted)="uploadsHistory.addNewUploadStatus($event)"
></app-upload-options>

<app-uploads-history #uploadsHistory></app-uploads-history>
